var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5104 2.49027C11.1887 -0.829841 5.81228 -0.830339 2.49007 2.49027C-0.1811 5.16009 -0.68586 9.12992 0.893346 12.2914L0.017838 16.1406C-0.0959598 16.6409 0.352649 17.0895 0.853385 16.9757L4.70446 16.1006C10.3039 18.8949 17 14.8495 17 8.49752C17 6.22833 16.1158 4.09492 14.5104 2.49027ZM10.2733 10.6131H4.95409C4.56852 10.6131 4.25595 10.3006 4.25595 9.91525C4.25595 9.52986 4.56852 9.21745 4.95409 9.21745H10.2733C10.6589 9.21745 10.9714 9.52986 10.9714 9.91525C10.9714 10.3006 10.6589 10.6131 10.2733 10.6131ZM12.0464 7.77755H4.95409C4.56852 7.77755 4.25595 7.46513 4.25595 7.07975C4.25595 6.69436 4.56852 6.38195 4.95409 6.38195H12.0464C12.432 6.38195 12.7445 6.69436 12.7445 7.07975C12.7445 7.46513 12.4319 7.77755 12.0464 7.77755Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.d39fa28281c9e96722b5571a4a9c19fb.svg";
export { ForwardRef as ReactComponent };